export default {"src":"/_next/static/media/anorak_logo.ed6dd7f0.svg","height":66,"width":294,"blurWidth":0,"blurHeight":0};